var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowRightColorC8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "15px",
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowRightColorC8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.498102679
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verify-your-Account",
    transform: "translate(-345.000000, -225.000000)",
    fill: "#C8C8C8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.024331,232.503171 L353.755383,226.891463 C353.913189,226.737317 354,226.53122 354,226.311463 C354,226.091585 353.913189,225.88561 353.755383,225.73122 L353.253197,225.239756 C353.095641,225.085122 352.885027,225 352.660587,225 C352.436148,225 352.225783,225.085122 352.068102,225.239756 L345.244371,231.920976 C345.086068,232.075854 344.999381,232.282805 345,232.502805 C344.999381,232.72378 345.085943,232.930488 345.244371,233.085488 L352.06175,239.760244 C352.21943,239.914878 352.429796,240 352.65436,240 C352.878799,240 353.089164,239.914878 353.24697,239.760244 L353.749031,239.26878 C354.075727,238.948902 354.075727,238.428171 353.749031,238.108415 L348.024331,232.503171 Z",
    id: "icArrowRightColorC8",
    transform: "translate(349.500000, 232.500000) scale(-1, 1) translate(-349.500000, -232.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightColorC8);
export default __webpack_public_path__ + "static/media/icArrowRightColorC8.33d2eeb9eb13646c7bbccc90e035b56a.svg";
export { ForwardRef as ReactComponent };